import React, { useEffect, useState } from "react";

interface TaglineProps {
  className?: string;
}

const Tagline: React.FC<TaglineProps> = ({ className }) => {
  const [headline, setHeadline] = useState<string>("");

  const generateHeadline = (): string => {
    const headlines = [
      "L'incertitude, c'est notre spécialité",
      "Pour ceux qui aiment les surprises",
      "Votre dose quotidienne d'imprévisibilité",
      "Nous devinons, vous décidez !",
      "La météo : un art, pas une science !",
      "Pour des aventures sans air plein d'imprévus",
      "Nos experts prévoient des averses d'absurdités tout au long de la journée",
      "80% de chances de pluie; 100% de chances de confusion",
      "Un soleil radieux, mais seulement chez votre voisin.",
      "De la météo 'plutôt bien', ce qui veut dire 'atroce'",
      "Nos astrologues se prononcent...",
      "Un temps merveilleux pour les personnes qui ne sortent pas",
      "Des prévisions 'acceptables' si vous ne regardez pas dehors",
      "Pour des averses de doutes et de questionnements",
      "Préparez-vous à des averses de sarcasme et de scepticisme",
      "La prévision sur laquelle vous ne pouvez pas compter",
    ];

    const randomIndex = Math.floor(Math.random() * headlines.length);
    return headlines[randomIndex];
  };

  useEffect(() => {
    setHeadline(generateHeadline());
  }, []);

  return (
    <h1
      className={`py-4 text-3xl leading-tight font-semibold sm:text-5xl lg:text-6xl ${className || ""}`}
    >
      {headline}
    </h1>
  );
};

export default Tagline;
